module.exports = __webpack_public_path__ + "static/media/ol.38466778.svg";